module.exports = __webpack_public_path__ + "media/images/icon-map-active-993e8f1437ca25905a25e62f2956d025.svg";